import { useRef } from "react";
import { OrdinaryButton } from "../Buttons";
import { Box } from "@mui/material";

const FileInput = ({ id, value, onChange, buttonText }) => {
    const fileInputRef = useRef();

    return <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <OrdinaryButton
            text={buttonText}
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
        />
        <input
            ref={fileInputRef}
            type="file"
            accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
            hidden
            onChange={onChange}
        />
    </Box>
}

export default FileInput;